// extracted by mini-css-extract-plugin
export var copy = "media-copy-block-module--copy--cea82";
export var grid = "media-copy-block-module--grid--91bb0";
export var media = "media-copy-block-module--media--f33cd";
export var root = "media-copy-block-module--root--81414";
export var text = "media-copy-block-module--text--c15f5";
export var title = "media-copy-block-module--title--c283e";